// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609041704/js/" + chunkId + "." + {"44":"bd586188","225":"baf8ba25","481":"d1acada0","486":"32ba9194","770":"75aeb27d"}[chunkId] + ".0.6732317235752474.chunk.js";
};